import { FetchTemplatesRequest } from '@containers/templates/templates.actions'
import { getTemplatesState } from '@containers/templates/templates.selectors'
import { environment } from '@env/environment'
import {
  SetDefaultData,
  FetchCommercialLicenseMappingRequest,
  UpdateField,
  UpdateCommercialLicenseMappingRequest,
} from '../commercial-license-mappings.actions'
import { getUpdateCommercialLicenseMappingState } from '../commercial-license-mappings.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'
import jsonToFormData from 'json-form-data'

@Component({
  selector: 'app-update-commercial-license-mapping',
  templateUrl: './update-commercial-license-mapping.component.html',
  styleUrls: ['./update-commercial-license-mapping.component.css'],
})
export class UpdateCommercialLicenseMappingComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  private templatesState$: Subscription
  public isLoading: boolean
  public templateId: number
  public templates: [] = []

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.templateId = parseInt(this.route.snapshot.paramMap.get('id'), 10)
    this.store.dispatch<any>(
      new SetDefaultData('updateCommercialLicenseMapping'),
    )
    this.state$ = this.store
      .pipe(select(getUpdateCommercialLicenseMappingState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.templatesState$ = this.store
      .pipe(select(getTemplatesState))
      .subscribe((state) => {
        this.templates = state.get('data').toJS()
      })

    this.store.dispatch<any>(
      new FetchTemplatesRequest({
        pageSize: 500,
      }),
    )

    this.store.dispatch<any>(
      new FetchCommercialLicenseMappingRequest(this.templateId),
    )
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.templatesState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'updateCommercialLicenseMapping.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'updateCommercialLicenseMapping',
      ),
    )
  }

  private validation() {
    const data = this.state.get('data')
    const rules = {
      propertyType: 'required',
      rate: 'required|numeric',
      templateId: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new UpdateCommercialLicenseMappingRequest(this.templateId, payload),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'updateCommercialLicenseMapping',
        ),
      )
    }
  }
}
